<template>
  <b-card>
    <b-card-body v-if="ready" class="p-1">
      <div class="clearfix">
        <div class="float-end">
          <div class="input-group input-group-sm">
            <select class="form-select form-select-sm" v-model="duration" @change="handleSelection">
              <option value="day" selected>{{ $t('pages.dashboard.email_statistics.daily') }}</option>
              <option value="week" selected>{{ $t('pages.dashboard.email_statistics.weekly') }}</option>
              <option value="month">{{ $t('pages.dashboard.email_statistics.monthly') }}</option>
            </select>
          </div>
        </div>
        <h4 class="card-title mb-4">{{ $t('pages.dashboard.sales_chart.title') }}
          <span class="text-muted">({{ $t('pages.dashboard.sales_chart.last_days', {days: this.date}) }})</span>
        </h4>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div class="text-muted">
            <div class="mb-4">
              <p>
                {{ $t('pages.dashboard.sales_chart.marketplace') }}:
                <market-place-chip class="mb-3" :marketPlaceId="marketplace"/>
              </p>
              <div>
                {{ $t('pages.dashboard.sales_chart.daily_average') }}
                <span class="badge badge-soft-success font-size-12 me-1">
                     {{ averageSales }}
                </span>
              </div>
            </div>

            <div class="mt-4">
              <p class="mb-2">{{ $t('pages.dashboard.sales_chart.currency') }}:
                <strong>{{ statistics.data.currency }}</strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-8" v-if="statistics.id">
          <apexchart
              class="apex-charts"
              dir="ltr"
              type="line"
              height="415"
              :series="series"
              :options="chartOptions"
          ></apexchart>
        </div>
      </div>
    </b-card-body>
    <b-card-body v-else>
      <chart-skeleton :height="500"/>
    </b-card-body>
  </b-card>
</template>

<script>
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";
import ChartSkeleton from "../../../components/Skeletons/ChartSkeleton";
import ReviewStatMixin from "../../../mixins/ReviewStatMixin";

export default {
  name: "SalesChart",
  components: {ChartSkeleton, MarketPlaceChip},
  mixins: [ReviewStatMixin],
  props: ['statistics', 'marketplace', 'date'],
  data() {
    return {
      ready: false,
      series: [],
      averageSales: 0,
      chartOptions: {
        xaxis: {
          type: 'datetime',
          categories: [],
        },
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2
          },
        },
        yaxis: {
          title: {
            text: this.$t('pages.dashboard.sales_chart.total')
          },
        },
        dataLabels: {
          enabled: false
        },
        colors: ['#556ee6'],
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            formatter: val => {
              return this.tooltipFormatter(val)
            }
          }
        },
      }
    }
  },
  watch: {
    'statistics.data'() {
      this.calculateChartData()
    }
  },
  methods: {
    async handleSelection() {
      this.ready = false
      await this.calculateChartData()
      this.ready = true
    },
    async calculateChartData() {
      this.ready = false

      const chartData = await this.groupAndBuild(this.statistics.data.series, this.duration, this.duration)
      const sales = []
      const categories = []
      let totalSales = 0

      chartData.map(x => {
        categories.push(x[this.duration])
        sales.push(x.value)
        totalSales = totalSales + parseFloat(x.value)
      })

      this.series = [
        {name: this.$t('pages.dashboard.sales_chart.sales'), data: sales},
      ]

      this.averageSales = (totalSales / this.date).toFixed(2)
      this.chartOptions.xaxis.categories = categories

      this.ready = true
    }
  }
}
</script>

<style scoped>

</style>